const o = "Pole koloru, bieżący kolor to {color}", l = "Color field", r = "Colors palette", e = "Gotowe kolory", t = "Custom preset colors", c = "Add color", s = "Wyczyść kolor", d = "Custom color, HEX format", C = "Dodaj kolor do listy kolorów niestandardowych", n = "Wyczyść pole koloru niestandardowego", a = "Delete color with backspace", i = {
  currentColor: o,
  emptyColor: l,
  palette: r,
  presetColors: e,
  customColors: t,
  addColor: c,
  clearColor: s,
  colorField: d,
  colorFieldConfirm: C,
  colorFieldClear: n,
  deleteColorDescriber: a
};
export {
  c as addColor,
  s as clearColor,
  d as colorField,
  n as colorFieldClear,
  C as colorFieldConfirm,
  o as currentColor,
  t as customColors,
  i as default,
  a as deleteColorDescriber,
  l as emptyColor,
  r as palette,
  e as presetColors
};
